module.exports = __webpack_public_path__ + "static/img/so1_3.a7e402d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/pic/so1_3.jpg
// module id = Ol+q
// module chunks = 11